(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["download-library"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-download-library]').forEach((library) => {
    const searchInput = library.querySelector('[data-download-search-input]');
    const typeFilter = library.querySelector('[data-download-type-filter]');
    const cards = Array.from(library.querySelectorAll('[data-download-card]'));
    const emptyState = library.querySelector('[data-download-empty]');
    const pagination = library.querySelector('[data-download-pagination]');

    const filterCards = () => {
      const query = searchInput?.value.trim().toLowerCase() || '';
      const type = typeFilter?.value || 'all';
      let visibleCount = 0;

      cards.forEach((card) => {
        const matchesQuery = !query || card.dataset.downloadSearch.includes(query);
        const matchesType = type === 'all' || card.dataset.downloadType === type;
        const visible = matchesQuery && matchesType;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (pagination) pagination.hidden = Boolean(query) || type !== 'all';
    };

    searchInput?.addEventListener('input', filterCards);
    typeFilter?.addEventListener('change', filterCards);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etmy-article-faq"] && !Shopify.designMode) return;
  try {
    
  // Auto-extraction fallback: If the article body has an H2 for FAQ, parse and migrate it into this dedicated section
  document.addEventListener('DOMContentLoaded', () => {
    const faqContainer = document.querySelector('[data-etmy-faq-container]');
    const articleBody = document.querySelector('[data-etmy-article-content]');
    if (!faqContainer || !articleBody) return;

    // Check if metafields already populated FAQs
    if (faqContainer.children.length === 0) {
      // Find FAQ heading in RTE
      const headings = Array.from(articleBody.querySelectorAll('h2'));
      const faqH2 = headings.find(h => /frequently asked questions|faq|常见问题/i.test(h.textContent));
      
      if (faqH2) {
        let currentNode = faqH2.nextElementSibling;
        let faqCount = 0;
        const nodesToRemove = [faqH2];

        while (currentNode && currentNode.tagName !== 'H2') {
          if (currentNode.tagName === 'H3') {
            const question = currentNode.textContent;
            nodesToRemove.push(currentNode);
            
            // Collect answer paragraphs until next H3 or H2
            let answerHtml = '';
            let nextEl = currentNode.nextElementSibling;
            while (nextEl && nextEl.tagName !== 'H3' && nextEl.tagName !== 'H2') {
              answerHtml += nextEl.outerHTML;
              nodesToRemove.push(nextEl);
              nextEl = nextEl.nextElementSibling;
            }

            const item = document.createElement('details');
            item.className = 'etmy-faq-item';
            if (faqCount === 0) item.setAttribute('open', '');
            item.innerHTML = `
              <summary>
                <span class="etmy-faq-item__q">${question}</span>
                <span class="etmy-faq-item__icon" aria-hidden="true">+</span>
              </summary>
              <div class="etmy-faq-item__a rte">${answerHtml}</div>
            `;
            faqContainer.appendChild(item);
            faqCount++;
            currentNode = nextEl;
          } else {
            currentNode = currentNode.nextElementSibling;
          }
        }

        // Clean up extracted FAQ from main text
        nodesToRemove.forEach(node => node.remove());
      }
    }

    // Toggle icon animation (+ / −)
    document.querySelectorAll('.etmy-faq-item').forEach(details => {
      details.addEventListener('toggle', () => {
        const icon = details.querySelector('.etmy-faq-item__icon');
        if (icon) {
          icon.textContent = details.open ? '−' : '+';
        }
      });
      const icon = details.querySelector('.etmy-faq-item__icon');
      if (icon) icon.textContent = details.open ? '−' : '+';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etmy-authority-article"] && !Shopify.designMode) return;
  try {
    
  // Strict H2-Only TOC Generator
  const tocContainer = document.querySelector('[data-etmy-toc]');
  const articleRoot = document.querySelector('[data-etmy-article-content]');
  if (tocContainer && articleRoot) {
    const headings = Array.from(articleRoot.querySelectorAll('h2')).filter(h => {
      // Exclude FAQ and Sources from TOC to keep TOC clean
      const text = h.textContent.trim().toLowerCase();
      return !text.includes('frequently asked questions') && !text.includes('faq') && !text.includes('sources');
    });

    if (headings.length > 0) {
      headings.forEach((heading, index) => {
        if (!heading.id) {
          heading.id = `section-${index + 1}`;
        }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${heading.id}`;
        a.textContent = heading.textContent;
        li.appendChild(a);
        tocContainer.appendChild(li);
      });
    } else {
      const tocAside = tocContainer.closest('.etmy-authority-article__toc-wrap');
      if (tocAside) tocAside.style.display = 'none';
    }

    // ScrollSpy Active Heading Tracker
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          tocContainer.querySelectorAll('a').forEach(a => {
            a.classList.toggle('is-active', a.getAttribute('href') === `#${id}`);
          });
        }
      });
    }, { rootMargin: '0px 0px -70% 0px' });

    headings.forEach(h => observer.observe(h));
  }

  // Transform uploaded Shopify PDF link at top of article into Download Card automatically
  if (articleRoot) {
    const topPdfLink = articleRoot.querySelector('p > a[href*="cdn.shopify.com"][href*=".pdf"]');
    if (topPdfLink) {
      const parentP = topPdfLink.closest('p');
      const downloadUrl = topPdfLink.getAttribute('href');
      const linkText = topPdfLink.textContent.trim();

      const card = document.createElement('div');
      card.className = 'etmy-download-card';
      card.innerHTML = `
        <div class="etmy-download-card__icon" aria-hidden="true">📄</div>
        <div class="etmy-download-card__info">
          <span class="etmy-download-card__badge">Downloadable PDF Resource</span>
          <strong class="etmy-download-card__title">${linkText}</strong>
        </div>
        <a class="etmy-download-card__btn" href="${downloadUrl}" target="_blank" rel="noopener" download>
          Download PDF ↓
        </a>
      `;
      parentP.replaceWith(card);
    }

    // Mode C: Auto FAQ Accordion Parsing
    const headings = Array.from(articleRoot.querySelectorAll('h2'));
    const faqH2 = headings.find(h => /frequently asked questions|faq|常见问题/i.test(h.textContent));
    if (faqH2) {
      const faqWrap = document.createElement('section');
      faqWrap.className = 'etmy-article-faq-block';
      faqWrap.id = 'faq';
      faqWrap.innerHTML = `
        <p class="etmy-authority-article__eyebrow">❓ FAQ</p>
        <h2>${faqH2.textContent}</h2>
        <div class="etmy-faq-accordion"></div>
      `;
      const accordion = faqWrap.querySelector('.etmy-faq-accordion');
      
      let currentNode = faqH2.nextElementSibling;
      const nodesToRemove = [faqH2];
      let faqIndex = 0;

      while (currentNode && currentNode.tagName !== 'H2') {
        if (currentNode.tagName === 'H3') {
          const qText = currentNode.textContent;
          nodesToRemove.push(currentNode);
          let ansHtml = '';
          let nextEl = currentNode.nextElementSibling;
          while (nextEl && nextEl.tagName !== 'H3' && nextEl.tagName !== 'H2') {
            ansHtml += nextEl.outerHTML;
            nodesToRemove.push(nextEl);
            nextEl = nextEl.nextElementSibling;
          }

          const details = document.createElement('details');
          details.className = 'etmy-faq-item';
          if (faqIndex === 0) details.setAttribute('open', '');
          details.innerHTML = `
            <summary>
              <span>${qText}</span>
              <span class="etmy-faq-icon">+</span>
            </summary>
            <div class="rte">${ansHtml}</div>
          `;
          accordion.appendChild(details);
          faqIndex++;
          currentNode = nextEl;
        } else {
          currentNode = currentNode.nextElementSibling;
        }
      }

      // Insert accordion block right before author card or at end of content
      faqH2.parentNode.insertBefore(faqWrap, faqH2);
      nodesToRemove.forEach(n => n.remove());

      // FAQ toggle icon handler
      faqWrap.querySelectorAll('details').forEach(d => {
        d.addEventListener('toggle', () => {
          const icon = d.querySelector('.etmy-faq-icon');
          if (icon) icon.textContent = d.open ? '−' : '+';
        });
      });
    }

    // Strip external jump links from Sources / References section (convert <a> to plain text citations)
    const sourcesH2 = headings.find(h => /sources|references|参考来源|引用来源/i.test(h.textContent));
    if (sourcesH2) {
      sourcesH2.id = 'sources';
      let nextNode = sourcesH2.nextElementSibling;
      while (nextNode && nextNode.tagName !== 'H2') {
        const links = nextNode.querySelectorAll('a');
        links.forEach(a => {
          const span = document.createElement('span');
          span.className = 'etmy-source-citation';
          span.textContent = a.textContent.trim();
          a.replaceWith(span);
        });
        nextNode = nextNode.nextElementSibling;
      }
    }
  }

  // Sticky bottom conversion bar
  const sticky = document.querySelector('[data-etmy-sticky]');
  if (sticky) {
    const revealAt = Math.max(640, window.innerHeight * 0.9);
    const updateSticky = () => { sticky.hidden = window.scrollY < revealAt; };
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etmy-product-aplus"] && !Shopify.designMode) return;
  try {
    
  class EtmyProductAplus extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-aplus-tab]')]
      this.panels = [...this.querySelectorAll('[data-aplus-panel]')]
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab))
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab))
      })

      // Check URL hash on initial load
      this.checkUrlHash()
      window.addEventListener('hashchange', () => this.checkUrlHash())

      // Global click handler for Judge.me review badges or review anchor links
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.jdgm-preview-badge, .jdgm-widget--preview, [href*="#reviews"], [href*="#judgeme"]')
        if (trigger) {
          const reviewsTab = this.querySelector('[data-aplus-tab="reviews"]')
          if (reviewsTab) {
            this.activate(reviewsTab)
            this.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        }
      })
    }

    checkUrlHash() {
      const hash = window.location.hash.toLowerCase()
      if (hash === '#reviews' || hash === '#judgeme' || hash.includes('judgeme') || hash.includes('review')) {
        const reviewsTab = this.querySelector('[data-aplus-tab="reviews"]')
        if (reviewsTab) this.activate(reviewsTab)
      } else if (hash === '#detail') {
        const detailTab = this.querySelector('[data-aplus-tab="detail"]')
        if (detailTab) this.activate(detailTab)
      } else if (hash === '#feature' || hash === '#features' || hash === '#specs') {
        const featureTab = this.querySelector('[data-aplus-tab="features"]')
        if (featureTab) this.activate(featureTab)
      } else if (hash === '#downloads' || hash === '#download') {
        const downloadsTab = this.querySelector('[data-aplus-tab="downloads"]')
        if (downloadsTab) this.activate(downloadsTab)
      }
    }

    activate(tab) {
      const update = () => {
        this.tabs.forEach((item) => {
          const selected = item === tab
          item.setAttribute('aria-selected', selected ? 'true' : 'false')
          item.tabIndex = selected ? 0 : -1
        })
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.aplusPanel === tab.dataset.aplusTab
          panel.hidden = !isActive
        })

        // Re-initialize / render Judge.me when reviews tab is opened
        if (tab.dataset.aplusTab === 'reviews') {
          if (window.jdgm && typeof window.jdgm.trigger === 'function') {
            window.jdgm.trigger('judgeme:load')
          }
          if (window.jdgm && typeof window.jdgm.render === 'function') {
            window.jdgm.render()
          }
          window.dispatchEvent(new Event('resize'))
        }
      }
      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(update)
      } else {
        update()
      }
    }

    handleKeydown(event, tab) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
      event.preventDefault()
      let index = this.tabs.indexOf(tab)
      if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length
      if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length
      if (event.key === 'Home') index = 0
      if (event.key === 'End') index = this.tabs.length - 1
      this.activate(this.tabs[index])
      this.tabs[index].focus()
    }
  }

  if (!customElements.get('etmy-product-aplus')) customElements.define('etmy-product-aplus', EtmyProductAplus)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
